import { EChatV2Status, IChatV2Schema, IMessageV2Schema } from '@cian/chats-api';

import { mapOfferV2VersionToV1 } from './mapOffer';
import { mapUserV2VersionToV1 } from './mapUser';
import { IMessageListItemV2Schema } from '../../repositories/chats/entities/message_list_item_v2/MessageListItemV2Schema';
import { TChatDataInListSchema, TSingleChatV2Response } from '../../types/chatList';

function transformLastMessageAppToV2(message: IMessageListItemV2Schema | IMessageV2Schema): IMessageV2Schema {
  const { type, bubbles, actionButtons, actionButtonsV3, status } = message;

  return {
    ...message,
    actionButtons: actionButtons as IMessageV2Schema['actionButtons'],
    actionButtonsV3: actionButtonsV3 as IMessageV2Schema['actionButtonsV3'],
    bubbles: bubbles as IMessageV2Schema['bubbles'],
    type: type as unknown as IMessageV2Schema['type'],
    status: status as unknown as IMessageV2Schema['status'],
    rowVersion: 0,
    rowVersionV2: '0',
  };
}

export const mapChatV2VersionToV1 = (chat: IChatV2Schema | TSingleChatV2Response): TChatDataInListSchema => {
  const updatedMs = new Date(chat.datetimeForSorting).getTime();

  return {
    archived: chat.status === EChatV2Status.Archived,
    availableActions: chat.availableActions,
    blocked: chat.status === EChatV2Status.Blocked,
    chatId: chat.chatId,
    created: updatedMs,
    createdMs: updatedMs,
    customActions: chat.customActions,
    data: {
      offer: mapOfferV2VersionToV1(chat.offer),
    },
    deleted: chat.status === EChatV2Status.Deleted,
    description: chat.description,
    lastMessage: chat.lastMessage ? transformLastMessageAppToV2(chat.lastMessage) : undefined,
    title: '',
    type: chat.type,
    unread: chat.unreadMessagesCount,
    updated: updatedMs,
    updatedMs,
    users: chat.users.map(mapUserV2VersionToV1),
    withModerator: false,
    isStarred: chat.isStarred || false,
  };
};
